import { render, staticRenderFns } from "./NaplataReport.vue?vue&type=template&id=171a2176"
import script from "./NaplataReport.vue?vue&type=script&lang=js"
export * from "./NaplataReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports